export const DataLayerEvents = {
  BURO_ACCEPTANCE_VIEW: "BuroAcceptance_view",
  LEADINFO_REGISTERED: "leadinfo_registered",
  SELECT_ITEM: "select_item",
  VIEW_ITEM: "view_item",
  START_KYC_VIEW: "StartKYC_view",
  BEGIN_CHECKOUT: "begin_checkout",
  KYC_APPROVED: "kyc_approved",
  LEADINFO_VIEW: "Leadinfo_view",
  OFFER_SELECTION_VIEW: "OfferSelection_view",
  RISK_REVIEW_REJECTED: "RiskReview_Rejected",
};

export default DataLayerEvents;
